'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThingTypeRest = function () {
  function ThingTypeRest($http) {
    (0, _classCallCheck3.default)(this, ThingTypeRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      TYPES_LIST: 'thing-types/',
      TYPES_DETAIL: 'thing-types/%1$s/'

    };
  }

  (0, _createClass3.default)(ThingTypeRest, [{
    key: 'getList',
    value: function getList(params) {
      return this.$http.get(this.PATH.TYPES_LIST, { params: params });
    }
  }, {
    key: 'get',
    value: function get(id) {
      return this.$http.get(this.sprintf(this.PATH.TYPES_DETAIL, id));
    }
  }]);
  return ThingTypeRest;
}();

exports.default = ThingTypeRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/ThingTypeResource.js
// module id = 330
// module chunks = 0